<template>
  <div class="frisbuy-slide-wrapper-elements">
    <div class="frisbuy-slide-wrapper-elements__header">
      <StoryProgressBar
        v-if="postCount > 0"
        :postCount="postCount"
        :currentPostIndex="currentPostIndex"
        :percentOfProgress="percentOfProgress"
        :isHideIg="isHideIg"
        @selectStep="(index) => $emit('selectStep', index)"
      />

      <div class="frisbuy-account-controls" v-if="!isHideIg && igAccount">
        <a
          class="frisbuy-account-avatar"
          :href="igAccount.profileLink"
          target="_blank"
          :style="{ 'background-image': `url(${igAccount.avatarUrl})` }"
          @click="() => $emit('clickInstagram')"
        ></a>
        <a
          class="frisbuy-account-name"
          :href="igAccount.profileLink"
          target="_blank"
          @click="() => $emit('clickInstagram')"
          >{{ igAccount.username }}</a
        >
        <!-- <a
          class="frisbuy-account-subscribe"
          :href="igAccount.profileLink"
          target="_blank"
          @click="() => $emit('clickInstagram')"
        >
          {{ igSubscribeButtonText || "Подписаться" }}
        </a> -->
      </div>

      <AdvertisingLabel
        v-if="adsMarker"
        class="frisbuy-advertising-marker"
        :backgroundColor="adsMarker.customization.backgroundColor"
        :color="adsMarker.customization.color"
        :offset="10"
        :arrowSettings="{ x: 16 }"
        placement="bottom-start"
      >
        <AdvertisingPopover
          :erid="adsMarker.info.erid"
          :advertiser="adsMarker.info.advertiser"
          :inn="adsMarker.info.inn"
          :note="adsMarker.info.note"
        />
      </AdvertisingLabel>

      <div class="frisbuy-control-elements">
        <PauseButton :isPause="isPause" @click="$emit('clickPause')" />

        <MuteButton
          v-if="isHasSound"
          :isSoundOn="isSoundOn"
          @click="$emit('clickMute')"
        />

        <PreviewCloseButton @click="$emit('clickClose')" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.frisbuy-slide-wrapper-elements {
  display: flex;
  width: 100%;

  .frisbuy-slide-wrapper-elements__header {
    display: flex;
    position: relative;
    flex-direction: row;
    flex-wrap: wrap;

    width: 100%;

    padding: 10px 7px 0;

    &:before {
      content: "";
      width: 100%;
      border-radius: 0 4px 0 0;
      top: 0;
      left: 0;
      z-index: 1;
      position: absolute;
      pointer-events: none;
      height: 70px;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), transparent);
    }

    @media (min-width: 768px) {
      margin-top: 2vh;
      padding: 14px 18px 0;
    }

    .frisbuy-account-controls {
      display: flex;
      position: relative;

      color: #fff;

      flex-shrink: 0;
      align-items: center;
      background-color: transparent;

      width: fit-content;

      margin-top: 8px;

      z-index: 11;
    }

    .frisbuy-control-elements {
      display: flex;
      position: relative;
      flex-direction: row;
      // top: 16px;
      // right: 19px;

      margin: 16px 0 0 auto;

      z-index: 3;

      & > *:not(:first-child) {
        margin-left: 26px;
      }

      .frisbuy-preview-close-button {
        @media (min-width: 768px) {
          display: none;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.frisbuy-slide-wrapper-elements {
  .frisbuy-slide-wrapper-elements__header {
    .frisbuy-advertising-marker {
      position: relative;

      width: fit-content;

      margin-top: 12px;

      z-index: 3;

      .frisbuy-popover__tooltip {
        // 14px - double left padding of frisbuy-slide-wrapper-elements__header
        width: calc(100vw - 14px);
        max-width: 340px;
      }
    }
  }
}
</style>

<script>
import {
  MuteButton,
  PauseButton,
  PreviewCloseButton,
  // StoryProgressBar,
} from "@/components/stories";

// I DON'T KNOW WHY THIS COMPONENT CANNOT BE IMPORTED VIA {} from "@/components/stories"
import StoryProgressBar from "@/components/stories/StoryProgressBar.vue";

import {
  AdvertisingLabel,
  AdvertisingPopover,
} from "@frisbuy/frisbuy-ui-components";

export default {
  components: {
    StoryProgressBar,
    PauseButton,
    MuteButton,
    PreviewCloseButton,

    AdvertisingLabel,
    AdvertisingPopover,
  },

  emits: [
    "selectStep",
    "clickInstagram",
    "clickPause",
    "clickMute",
    "clickClose",
  ],

  props: {
    postCount: {
      type: Number,
      require: false,
      default: 0,
    },
    currentPostIndex: {
      type: Number,
      require: false,
      default: 0,
    },
    percentOfProgress: {
      type: Number,
      require: false,
      default: 0,
    },
    isHideIg: {
      type: Boolean,
      require: false,
      default: false,
    },

    igAccount: {
      type: Object,
      require: false,
      default: undefined,
    },
    igSubscribeButtonText: {
      type: String,
      require: false,
      default: undefined,
    },

    isPause: {
      type: Boolean,
      require: false,
      default: false,
    },
    isHasSound: {
      type: Boolean,
      require: false,
      default: false,
    },
    isSoundOn: {
      type: Boolean,
      require: false,
      default: false,
    },

    adsMarker: {
      type: Object,
      require: false,
      default: undefined,
    },
  },

  data() {
    return {};
  },
};
</script>
